var subtract = "https://shopfront-cdn.tekoapis.com/static/61d838e201b3d02d.svg";

export { subtract as default };
